// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import myAccountFilterSectionStyles from "@west/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

userListHeaderStyles.searchGridItem = {
    width: [12, 12, 8, 6, 6],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
            padding-top: 8px;
        }
    `,
};

userListHeaderStyles.buttonsGridItem = {
    width: [2, 2, 4, 3, 3],
    css: css`
        justify-content: flex-end;
        padding-top: 21px;
    `,
};

userListHeaderStyles.searchContainer = {
    css: css`
        padding-bottom: 10px;
    `,
};

userListHeaderStyles.userCountGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.countGridItem, {
        css: css`
            ${xScreen("lte", "sm")} {
                order: 1;
                justify-content: start;
                padding-bottom: 0;
            }
        `,
    }),
    width: [12, 12, 4, 6, 6],
};

userListHeaderStyles.searchSubmitButton = {
    css: css`
        flex: 0 0 auto;
    `,
    variant: "tertiary",
};
